<template>
  <div>
    <div class="row mt-4">
      <div class="offset-sm-9 col-sm-3">
        <div class="input-group mb-3">
          <input
            type="text"
            class="form-control"
            v-model="globalSearch"
            @input="setData()"
          />
          <label for="sizeOptions" class="input-group-text"
            ><font-awesome-icon
              class="my-auto"
              :icon="['fas', 'magnifying-glass']"
          /></label>
        </div>
      </div>
    </div>
  </div>
  <div
    :class="`bg-${getColorMode.background} text-${getColorMode.text} border-${getColorMode.globalBackground} border-radius-20 shadow-table p-3`"
  >
    <table :class="`table table-${getColorMode.background}`">
      <thead>
        <tr>
          <th
            v-for="(value, key) in columns"
            v-bind:key="`table-column-${key}`"
          >
            {{ value.text }}
          </th>
          <th>Asignar</th>
        </tr>
        <tr v-if="1 == 0">
          <th
            v-for="(value, key) in columns"
            v-bind:key="`table-filter-column-${key}`"
          >
            <input
              type="text"
              :name="value.name"
              class="form-control"
              autocomplete="off"
            />
          </th>
          <th></th>
        </tr>
      </thead>
      <tbody v-if="rows.length > 0">
        <tr
          v-for="(row, keyRow) in rows"
          v-bind:key="`table-inner-row-${keyRow}`"
        >
          <td
            v-for="(column, keyColumn) in columns"
            v-bind:key="`table-column-${keyColumn}`"
          >
            {{ row[column.name] }}
          </td>
          <td>
            <input
              type="checkbox"
              :ref="'checkbox-' + row['id']"
              :checked="row['is_in_project']"
              @change="updateRolData(row['id'])"
            />
          </td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr>
          <td class="text-center py-5" :colspan="columns.length + 1">
            <span v-if="loading">Buscando...</span>
            <span v-else>No existen datos disponibles</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="row mt-4">
    <div class="col-sm-6 d-flex justify-content-start my-auto">
      <div>
        <span class="items-per-page-text mb-0">Items por página:</span>
        <select
          id="sizeOptions"
          v-model="size"
          class="border-secondary mx-2"
          aria-label="Default select example"
          @change="changeSize()"
        >
          <option
            v-for="(value, key) in sizeOptions"
            v-bind:key="`size-select-${key}`"
          >
            {{ value }}
          </option>
        </select>
      </div>
      <p class="table-entries-text mb-0 text-left">
        {{ calcSize }} registros de {{ total }}
      </p>
    </div>
    <div class="col-sm-6">
      <nav aria-label="Paginación">
        <ul class="pagination justify-content-end">
          <span class="mx-4 my-auto items-per-page-text"
            >Página {{ page }} de {{ lastPage }}</span
          >
          <template v-if="page > 1">
            <li class="page-item">
              <a class="page-link" href="javascript:;" @click="page = 1"
                ><font-awesome-icon :icon="['fal', 'chevrons-left']"
              /></a>
            </li>
            <li class="page-item" aria-current="page">
              <a href="javascript:;" class="page-link" @click="page = page - 1"
                ><font-awesome-icon :icon="['fal', 'chevron-left']"
              /></a>
            </li>
          </template>
          <template v-else>
            <li class="page-item disabled">
              <a
                class="page-link"
                href="javascript:;"
                tabindex="-1"
                aria-disabled="true"
                ><font-awesome-icon :icon="['fal', 'chevrons-left']"
              /></a>
            </li>
            <li class="page-item disabled">
              <a
                class="page-link"
                href="javascript:;"
                tabindex="-1"
                aria-disabled="true"
                ><font-awesome-icon :icon="['fal', 'chevron-left']"
              /></a>
            </li>
          </template>
          <li class="page-item active" aria-current="page">
            <span class="page-link">{{ page }}</span>
          </li>
          <template v-if="page < lastPage">
            <li class="page-item" aria-current="page">
              <a href="javascript:;" class="page-link" @click="page = page + 1"
                ><font-awesome-icon :icon="['fal', 'chevron-right']"
              /></a>
            </li>
            <li class="page-item">
              <a class="page-link" href="javascript:;" @click="page = lastPage"
                ><font-awesome-icon :icon="['fal', 'chevrons-right']"
              /></a>
            </li>
          </template>
          <template v-else>
            <li class="page-item disabled">
              <a
                class="page-link"
                href="javascript:;"
                tabindex="-1"
                aria-disabled="true"
                ><font-awesome-icon :icon="['fal', 'chevron-right']"
              /></a>
            </li>
            <li class="page-item disabled">
              <a
                class="page-link"
                href="javascript:;"
                tabindex="-1"
                aria-disabled="true"
                ><font-awesome-icon :icon="['fal', 'chevrons-right']"
              /></a>
            </li>
          </template>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "dataTable",
  props: {
    url: { default: "" },
    editUrl: { default: "" },
    assignRolesUrl: { default: "" },
    userId: { default: null },
    projectId: { default: null },
    sizeOptions: { type: Array, default: () => [10, 50, 100] },
  },
  data() {
    return {
      rows: [],
      columns: [],
      page: 1,
      size: this.sizeOptions[0],
      total: 0,
      globalSearch: "",
      loading: false,
    };
  },
  mounted() {
    this.setData();
  },
  methods: {
    changeSize() {
      if (this.page == 1) this.setData();
      this.page = 1;
    },
    async setData() {
      let app = this;
      this.rows = [];
      this.loading = true;
      this.axios
        .get(
          `${this.url}?size=${this.size}&page=${this.page}&search=${this.globalSearch}&project_id=${this.projectId}&user_id=${this.userId}`
        )
        .then((result) => {
          app.rows = result.data.body.data;
          app.total = result.data.body.total;
          app.columns = result.data.body.columns;
          app.loading = false;
        })
        .catch((error) => {
          app.loading = false;
          console.log(error);
        });
    },
    async updateRolData(roleId) {
      let app = this;
      this.loading = true;
      let checkboxSelected = `checkbox-${roleId}`;
      this.axios
        .post(`roles/update_role_by_user_and_project`, {
          role_id: roleId,
          user_id: this.userId,
          project_id: this.projectId,
          value: this.$refs[checkboxSelected][0].checked,
        })
        .then(() => {
          this.setData();
          app.loading = false;
        })
        .catch((error) => {
          app.loading = false;
          console.log(error);
        });
    },
  },
  computed: {
    ...mapGetters("general", ["getColorMode"]),
    lastPage() {
      return Math.ceil(parseFloat(this.total) / parseFloat(this.size));
    },
    calcSize() {
      return this.total < this.size ? this.total : this.size;
    },
  },
  watch: {
    page: {
      handler: function () {
        this.setData();
      },
    },
  },
};
</script>
